import React from "react";
import { classNames } from "../lib/utils";
import { API_BASE } from "../lib/api";

function initials(name = "") {
  const parts = String(name).trim().split(/\s+/);
  if (!parts.length) return "?";
  const first = parts[0]?.[0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
}

function colorPair(gender) {
  const g = String(gender || "").toLowerCase();
  if (g === "female") return ["#FAE8FF", "#A21CAF"]; // purple/pink
  return ["#E0F2FE", "#0369A1"]; // blue/sky for male/default
}

const SIZE = {
  xs: "h-7 w-7 text-[11.5px]",
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-14 w-14 text-base",
  xl: "h-20 w-20 text-xl",
};

// Resolve src for img tag — for our /api/files/* paths we append the bearer token as ?auth=
function resolveSrc(src) {
  if (!src) return "";
  // Already absolute URL (e.g. Google profile picture)
  if (/^https?:\/\//i.test(src)) return src;
  // Data URI
  if (src.startsWith("data:")) return src;
  // /api/files/... — prepend backend BASE (same-origin-aware) and append auth token query.
  // API_BASE ends with "/api". Avoid duplicating "/api" if src already starts with it.
  const baseRoot = API_BASE.replace(/\/api$/, "");
  const token = typeof window !== "undefined" ? localStorage.getItem("nv_jwt") : null;
  const sep = src.includes("?") ? "&" : "?";
  const authPart = token ? `${sep}auth=${encodeURIComponent(token)}` : "";
  return `${baseRoot}${src}${authPart}`;
}

export default function Avatar({ name = "", gender = "", src = "", size = "md", className = "", testId }) {
  const [bg, fg] = colorPair(gender);
  const [errored, setErrored] = React.useState(false);
  const resolved = resolveSrc(src);
  const showImg = resolved && !errored;
  if (showImg) {
    return (
      <img
        src={resolved}
        alt={name}
        data-testid={testId}
        className={classNames("rounded-full object-cover ring-2 ring-white shadow-sm", SIZE[size], className)}
        onError={() => setErrored(true)}
      />
    );
  }
  return (
    <div
      data-testid={testId}
      className={classNames("rounded-full flex items-center justify-center font-bold ring-2 ring-white shadow-sm", SIZE[size], className)}
      style={{ background: bg, color: fg }}
    >
      {initials(name)}
    </div>
  );
}
